<template>
   <wo-dropdown v-if="capabilities">
    <wo-link slot="toggle" mod-icon mod-icon-after icon="chevron-down">
      <po-display v-if="currentModule" :value="currentModule.module || currentModule" />
      <span v-else v-t="env.appTitleKey"></span>
      <po-module-icon :value="currentModule" aria-hidden="true" />
    </wo-link>
    <template slot="links">
      <template v-for="mod in modules">
        <wo-link :key="mod.id" v-if="mod.url" :href="mod.url"><po-display :value="mod.module" /></wo-link>
        <po-route-link v-else :key="mod.id" :to="mod.route" :value="mod.route" :label="mod.module.name" />
      </template>
      <template v-if="xsActions">
        <div class="wo-u-hidden--sm">
          <wo-link v-for="(item, index) in xsActions" :key="index" @click.native.prevent="execute(item)">
            <po-display :value="item" />
          </wo-link>
        </div>
      </template>
    </template>
  </wo-dropdown>
  <wo-link v-else-if="currentModule" href="#" slot="brand">
    <po-module-icon :value="currentModule" aria-hidden="true" />
    <po-display :value="currentModule" />
  </wo-link>
</template>
<script>

import _ from 'lodash'
import { mapState } from 'vuex'

export default {
  props: {
    xsActions: Array
  },
  computed: mapState({
    user: state => state.identity.currentUser,
    capabilities: state => state.identity.capabilities,
    currentModule: state => state.environment.applicationModule,
    env: state => state.environment.current,
    modules () {
      return this.capabilities && _.map(_.filter(this.capabilities.modules, m => m.enabled), this.createModule)
    },
    baseUrl () {
      return this.env.baseUrl
    }
  }),
  methods: {
    execute (action) {
      action.execute()
    },
    createModule (m) {
      const params = { companyId: this.user && this.user.company.id }
      const route = { name: m.route, params }
      const result = { ...m, route }
      return result
    }
  }
}
</script>
